export const dateFormat: string = 'dd/MM/yyyy';
export const dateTimeFormat: string = 'dd/MM/yyyy HH:mm:ss';
export const isoDateTimeFormat: string = "yyyy-MM-dd'T'HH:mm:ss.SSSSSSX";
export const timeFormat: string = 'HH:mm:ss';
export const durationFormat: string = 'hh:mm:ss';
export const intervalFormat: string = 'hh:mm:ss';
export const firstDayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 0;
export const zone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;

